import React, { useState, useEffect } from "react";
import {
  Button,
  Container,
  Grid,
} from "@material-ui/core";
import HomePage from "../../Home";
import { VRolesStyle } from "./styles";
import TRoles from "../TRoles";
import FRoles from "../FRoles";
import { useDispatch, useSelector } from "react-redux";
import { obtenerRolesAllAction } from "../../../ducks/rolDuck";
import BackDrop from "../../../global/BackDrop";
import ModalPermisos from "./../FPermiso/Modal";
const VRoles = () => {
  const Clasess = VRolesStyle();
  const dispatch = useDispatch();
  const roles = useSelector(
    (store) => store.roles.array
  );
  const [openModal, setOpenModal] = useState(false);
  const [rowTarget, setRowTarget] = useState({Id:0});
  const [editar, setEditar] = useState(false);
  const [isLoad, setIsLoad] = useState(false);
  const [isPermiso, setIsPermiso] = useState(false);
  useEffect(() => {
    setIsLoad(true);
    dispatch(obtenerRolesAllAction()).then(
      (Reposne) => {
        setIsLoad(false);
      }
    );
  }, [dispatch]);
  
  const handleOpen = () => {
    setOpenModal(!openModal);
    setEditar(false);
  };
  const onEditar = (rowTarget) => {
    setRowTarget(rowTarget);
    setEditar(true);
    setOpenModal(!openModal);
  };
  const onPermisos = (rowTarget) =>{
    setRowTarget(rowTarget);
    setIsPermiso(!isPermiso);
  }
  return (
    <HomePage>
      <Container>
        <Grid
          container
          direction="row"
          justifyContent="space-between"
          alignItems="center"
          className={Clasess.contentMargin}
        >
          <Grid item xs={12} className={Clasess.flexEnd}>
            <Button
              variant="outlined"
              color="primary"
              onClick={handleOpen}
            >
              Nuevo rol
            </Button>
          </Grid>
        </Grid>
        <Grid container>
          <Grid item xs={12}>
            <TRoles rows={roles} onEditar={onEditar} onPermiso={onPermisos} />
          </Grid>
        </Grid>
        <FRoles
          open={openModal}
          setOpen={setOpenModal}
          editar={editar}
          setEditar={setEditar}
          rowData={rowTarget}
        />
        <ModalPermisos
            open={isPermiso}
            setOpen={setIsPermiso}
            rowData={rowTarget}
        />
        <BackDrop open={isLoad} />
      </Container>
    </HomePage>
  );
};
export default VRoles;
